import { cn } from '@/app/utils'

export const styles = {
  pinned: cn(
    'absolute -right-2 -top-2 h-18 min-w-[18px] border border-transparent px-5 pt-1 !text-white text-12',
    'group-hover:border-grey-10 xs:group-hover:border-transparent'
  ),
  pinnedActive: 'border-grey-10',

  badge:
    'flex justify-center items-center h-20 min-w-[30px] px-6 !text-black text-14',
  badgeActive: ''
}
